export interface ISuburbReportLink {
    label: string;
    href: string;
}

export interface ISuburbReportLinkGroup {
    heading: string;
    links: ISuburbReportLink[];
}


export interface ISuburbReportPack {
    id: string;
    title: string;
    intro?: string;
    benefitsDescription?: string;
    benefits: string[];
    reportGroups: ISuburbReportLinkGroup[];
}

export const suburbReportPacks: ISuburbReportPack[] = [
    {
        id: "pack-1",
        title: "Pack 1. Mining Towns Growth and Performance",
        benefits: [
            "The suburbs producing over 9% gross rental yields right now - ideal if you are looking for positive cash flow.",
            "The suburbs with the fastest growth - a preliminary indicator of where the market in the area may be heading.",
            "The suburbs with steady growth over 5 years - which may point to a safe and stable investment.",
            "The suburbs experiencing a rapid upturn in rental returns over the last 12 months - which can indicate increased desirability in an area and future capital growth appreciation.",
            "The cheapest and most expensive mining towns so you can target areas with properties that match your strategy or buying rules.",
        ],
        reportGroups: [
            {
                heading: "Australia Nationwide Reports",
                links: [
                    {
                        label: "Highest yielding mining town suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Mining/Highest_yielding_mining_towns.pdf",
                    },
                    {
                        label: "Fastest median growth mining town suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Mining/Fastest_median_growth_mining_towns.pdf",
                    },
                    {
                        label: "Largest Average Annual Price Increase over 5 yrs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Mining/Mining_towns_with_largest_average_annual_median_price_increase_in_last_5_years.pdf",
                    },
                    {
                        label: "Fastest Rental Growth mining town suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Mining//Fastest_rental_growth_mining_towns.pdf",
                    },
                    {
                        label: "Cheapest mining town suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Mining/Cheapest_mining_towns.pdf",
                    },
                    {
                        label: "Most expensive mining town suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Mining/Most_expensive_mining_towns.pdf",
                    },
                ],
            },
        ],
    },
    {
        id: "pack-2",
        title: "Pack 2. Waterfront Growth and Performance",
        intro: "Learn a profusion of waterfront suburb trends and data including:",
        benefitsDescription: "The 32 waterfront suburbs that are producing over 50% median price growth right now. Buying in these high growth areas can lead to rapid equity gains.",
        benefits: [
            "The 25 waterfront suburbs producing over 8% gross rental yields right now, ideal if you are looking for better cash flow.",
            "In which 11 waterfront suburbs you can buy investment property for less than $150,000 so you can take immediate action.",
            "A general overview of the market so you can target waterfront areas with properties that match your strategy or buying rules.",
        ],
        reportGroups: [
            {
                heading: "Australia Top 200 at Nationwide and State Level",
                links: [
                    {
                        label: "Biggest Quarterly Mover Waterfront Suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Waterfront/Biggest_quarterly_mover_waterfront_suburbs.pdf",
                    },
                    {
                        label: "Biggest Turnaround Waterfront Suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Waterfront/Biggest_turnaround_waterfront_suburbs.pdf",
                    },
                    {
                        label: "Cheapest Waterfront Suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Waterfront/Cheapest_waterfront_suburbs.pdf",
                    },
                    {
                        label: "Fastest Median Growth Suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Waterfront/Fastest_median_growth_waterfront_suburbs.pdf",
                    },
                    {
                        label: "Highest Yielding Waterfront Suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Waterfront/Highest_yielding_waterfront_suburbs.pdf",
                    },
                    {
                        label: "Most Expensive Waterfront Suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/Waterfront/Most_expensive_waterfront_suburbs.pdf",
                    },
                ],
            },
        ],
    },
    {
        id: "pack-3",
        title: "Pack 3. Property Market: Affordability and Growth",
        intro: "These seven suburb reports give you in-depth suburb data at both a nationwide and state level.",
        benefitsDescription: "",
        benefits: [
            "Identifying suburbs experiencing the fastest rates of median growth.",
            "Targeting areas where owning is more affordable than renting.",
            "The suburbs with steady growth over 5 years - which may point to a safe and stable investment.",
            "Finding suburbs where you can purchase property for as little as $50,000.",
            "Avoiding the suburbs experiencing declining rates of median price growth which could lead to financial disaster.",
        ],
        reportGroups: [
            {
                heading: "Australia Top 200 at Nationwide and State Level",
                links: [
                    {
                        label: "Smarter to buy than rent suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/HomeBuyers/SmarterToOwnThanRentSuburbs.pdf",
                    },
                    {
                        label: "Cheapest rental suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/HomeBuyers/CheapestRentalSuburbs.pdf",
                    },
                    {
                        label: "Fastest median growth suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/HomeBuyers/Fastest1YrMedianGrowthSuburbs.pdf",
                    },
                    {
                        label: "Best 5 year growth average suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/HomeBuyers/Best5YrAvgAnnualMedianGrowthSuburbs.pdf",
                    },
                    {
                        label: "Cheapest suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/HomeBuyers/CheapestSuburbs.pdf",
                    },
                    {
                        label: "Biggest 5 year price decline suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/HomeBuyers/WorstTotal5YrMedianPriceDeclineSuburbs.pdf",
                    },
                    {
                        label: "Biggest average median price decline suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/AU/HomeBuyers/Biggest5YrAvgAnnualMedianPriceDeclineSuburbs.pdf",
                    },
                ],
            },
        ],
    },
    {
        id: "pack-4",
        title: "Pack 4. Property Market: Movers and Faders",
        intro: "These nine suburb reports give you in-depth suburb data at both a nationwide and state level.",
        benefitsDescription: "",
        benefits: [
            "Identifying suburbs experiencing strong or weak demand.",
            "Targeting areas with distressed listings that can lead to instant equity gains.",
            "Understanding population and income trends which affect the demand and desirability of a suburb.",
            "Predicting suburbs with future capital growth potential.",
            "Avoiding the suburbs that could spell financial disaster.",
        ],
        reportGroups: [
            {
                heading: "Australia Nationwide Reports",
                links: [
                    {
                        label: "Fastest time to sell suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/MoversAndFaders/Fastest_time_to_sell_suburbs_AU.pdf",
                    },
                    {
                        label: "Slowest time to sell suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/MoversAndFaders/Slowest_time_to_sell_suburbs_AU.pdf",
                    },
                    {
                        label: "Suburbs with the biggest price gap between top and bottom",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/MoversAndFaders/Biggest_price_gap_suburbs_AU.pdf",
                    },
                    {
                        label: "Suburbs with the highest percentage of renovation listings",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/MoversAndFaders/Highest_renovation_percentage_suburbs_AU.pdf",
                    },
                    {
                        label: "Suburbs with the highest percentage of distressed price listings",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/MoversAndFaders/Most_distressed_percentage_suburbs_AU.pdf",
                    },
                    {
                        label: "Fastest population growth suburbs",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/MoversAndFaders/Fastest_population_growth_suburbs_AU.pdf",
                    },
                    {
                        label: "Suburbs with the biggest decrease in stock on market",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/MoversAndFaders/Biggest_Stock_Decrease_suburbs_AU.pdf",
                    },
                    {
                        label: "Suburbs with the biggest increase in stock on the market",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/MoversAndFaders/Biggest_Stock_Increase_suburbs_AU.pdf",
                    },
                    {
                        label: "Suburbs with the biggest increase in household income",
                        href: "http://www.realestateinvestar.com.au/SuburbPerformanceReports/MoversAndFaders/Biggest_household_income_increase_suburbs_AU.pdf",
                    },
                ],
            },
        ],
    },
    {
        id: "pack-5",
        title: "Pack 5. Top Suburbs: Growth, Yield and Affordability",
        benefits: [
            "Target areas with properties that match your criteria and buying rules.",
            "Identify areas that are moving and target neighbouring suburbs that could move next.",
            "Discover the suburbs that are producing 10-30% capital growth right now. Investing in high growth areas rapidly increases your equity.",
            "Find the 30+ suburbs producing 10%+ gross rental yields right now - ideal if you are looking for positive cash flow.",
            "Learn in which suburbs you can buy investment property for as little as $50,000 so you can start investing now rather than sitting on the sideline.",
        ],
        reportGroups: [
            {
                heading: "Australia",
                links: [
                    {
                        label: "Top 100 Cheapest Suburbs",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/AUS_CheapestSuburbs.pdf",
                    },
                    {
                        label: "Top 100 Lowest Median Rents",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/AUS_CheapestRents.pdf",
                    },
                    {
                        label: "Top 200 Highest Yielding Suburbs",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/AUS_TopYieldingSuburbs.pdf",
                    },
                    {
                        label: "Top 100 Fastest Growth Suburbs",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/AUS_FastestGrowthSuburbs.pdf",
                    },
                    {
                        label: "Top 200 Fastest Rental Growth Suburbs",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/AUS_FastestRentalGrowthSuburbs.pdf",
                    },
                ],
            },
            {
                heading: "New Zealand",
                links: [
                    {
                        label: "Top 50 Cheapest Suburbs",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/NZ_CheapestSuburbs.pdf",
                    },
                    {
                        label: "Top 50 Lowest Median Rents",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/NZ_CheapestRents.pdf",
                    },
                    {
                        label: "Top 50 Highest Yielding Suburbs",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/NZ_TopYieldingSuburbs.pdf",
                    },
                    {
                        label: "Top 50 Fastest Growth Suburbs",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/NZ_FastestGrowthSuburbs.pdf",
                    },
                    {
                        label: "Top 50 Fastest Rental Growth Suburbs",
                        href: "http://www.realestateinvestar.com.au/Media/DocumentLibrary/myreports/NZ_FastestRentalGrowthSuburbs.pdf",
                    },
                ],
            },
        ],
    },
];